import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { FileElement } from 'src/app/shared/components/file-manager/model/element';
import { v4 } from 'uuid';

export interface IFileManagerService {
  add(fileElement: FileElement);
  delete(id: string);
  update(id: string, update: Partial<FileElement>);
  queryInFolder(folderId: string): Observable<FileElement[]>;
  get(id: string): FileElement;
  getMap(): Map<string, FileElement>;
}

@Injectable()
export class FileManagerService implements IFileManagerService {
  private map = new Map<string, FileElement>();

  constructor() { }
  reset() {
    this.map.clear();
  }

  add(fileElement: FileElement) {
    fileElement.id = v4();
    this.map.set(fileElement.id, this.clone(fileElement));
    return fileElement;
  }

  delete(id: string) {
    this.map.delete(id);
  }

  update(id: string, update: Partial<FileElement>) {
    let element = this.map.get(id);
    element = Object.assign(element, update);
    this.map.set(element.id, element);
  }

  private querySubject: BehaviorSubject<FileElement[]>;
  queryInFolder(folderId: string) {
    const result: FileElement[] = [];
    this.map.forEach(element => {
      if (element.parent === folderId) {
        result.push(this.clone(element));
      }
    });
    if (!this.querySubject) {
      this.querySubject = new BehaviorSubject(result);
    } else {
      this.querySubject.next(result);
    }
    return this.querySubject.asObservable();
  }

  get(id: string) {
    return this.map.get(id);
  }

  getMap() {
    return this.map;
  }

  getByName(name: string) {
    let foundElement: FileElement;
    this.map.forEach((value: FileElement, key: string, self: Map<string, FileElement>) => {
      if (value.name === name) {
        foundElement = self.get(key);
        return;
      }
    });
    return foundElement;
  }

  clone(element: FileElement) {
    return JSON.parse(JSON.stringify(element));
  }

  sort(key?: string, sortVers?: "asc" | "desc") {
    let vers = sortVers;
    if (!vers) {
      vers = "asc";
    }
    const newMap = new Map([...this.map.entries()].sort((a: any, b: any) => {
      if (
        Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === 2 &&
        b.length === 2
      ) {
        const aIsFolder = a[1].isFolder;
        const aFolderName = a[1].name;
        const bIsFolder = b[1].isFolder;
        const bFolderName = b[1].name;
        // if (aIsFolder && bIsFolder) {
        //   if (aFolderName < bFolderName) {
        //     return -1;
        //   }
        //   if (aFolderName > bFolderName) {
        //     return 1;
        //   }
        //   return 0;
        // }
        return aIsFolder === bIsFolder ? ((aFolderName > bFolderName) ? 1 : -1 ) : aIsFolder ? -1 : 1;
      }
      return 0;
    }));
    this.map = newMap;
  }
}
